var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "transfer bank" },
    [
      _vm.siteCode == _vm.$config.SITECODE_OGMMR
        ? [
            _c("cbmnet-manage-payees", {
              ref: "payees",
              attrs: { usePage: _vm.usePage, cncycd: _vm.baseCncycd }
            })
          ]
        : _vm.siteCode == _vm.$config.SITECODE_OGCBD
        ? [
            _c("cbd-manage-payees", {
              ref: "payees",
              attrs: { usePage: _vm.usePage, cncycd: _vm.baseCncycd }
            })
          ]
        : _vm.siteCode == _vm.$config.SITECODE_OGHCM
        ? [
            _vm.usePage == "napas"
              ? [
                  _c("napas-manage-payees", {
                    ref: "payees",
                    attrs: {
                      usePage: _vm.usePage,
                      cncycd: _vm.baseCncycd,
                      drowAcnInfo: _vm.drowAcnInfo
                    }
                  })
                ]
              : [
                  _c("vtn-manage-payees", {
                    ref: "payees",
                    attrs: { usePage: _vm.usePage, cncycd: _vm.baseCncycd }
                  })
                ]
          ]
        : _vm.siteCode == _vm.$config.SITECODE_OGIND
        ? [
            _c("ind-manage-payees", {
              ref: "payees",
              attrs: { usePage: _vm.usePage, cncycd: _vm.baseCncycd }
            })
          ]
        : _vm.siteCode == _vm.$config.SITECODE_OGAUC
        ? [
            _c("auc-manage-payees", {
              ref: "payees",
              attrs: { usePage: _vm.usePage, cncycd: _vm.baseCncycd }
            })
          ]
        : void 0
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }